import React from 'react'
import FiltrosAdicionadosFechamentoCaixa from '../FiltrosAdicionadosFechamentoCaixa'
import Filtro from '../../comum/Filtro'
import FiltroFechamentoCaixa from './FiltroFechamentoCaixa'
import PainelFiltragem from '../../comum/PainelFiltragem'

export const PainelFiltroFechamentoCaixa = () => (
  <Filtro PainelFiltro={FiltroFechamentoCaixa}/>
);

const PainelFiltrosFechamentoCaixa = () => (
  <PainelFiltragem
    Filtro={PainelFiltroFechamentoCaixa}
    FiltrosAdicionados={FiltrosAdicionadosFechamentoCaixa}/>
)

export default PainelFiltrosFechamentoCaixa
